import React, { memo, useCallback, useEffect, useRef, useState } from "react";

function SimpleDropdown({
   value,
   activeValue,
   displayLabel,
   onChange,
   options,
   placeholder = "",
   className = "",
   "aria-label": ariaLabel,
}) {
   const [open, setOpen] = useState(false);
   const ref = useRef(null);

   const handleToggle = useCallback(() => {
      setOpen((v) => !v);
   }, []);

   const handleSelect = useCallback(
      (val) => {
         onChange?.(val);
         setOpen(false);
      },
      [onChange],
   );

   useEffect(() => {
      if (!open) return undefined;

      const onClickOutside = (e) => {
         if (!ref.current) return;
         if (!ref.current.contains(e.target)) setOpen(false);
      };

      document.addEventListener("click", onClickOutside, true);
      return () => document.removeEventListener("click", onClickOutside, true);
   }, [open]);

   const selectedValue = activeValue ?? value;
   const current = options.find(
      (option) => String(option.value) === String(selectedValue),
   );
   const label = displayLabel ?? current?.label ?? placeholder ?? "";

   return (
      <div
         ref={ref}
         className={`dv-dd dv-select ${className || ""}`}
         aria-label={ariaLabel}
      >
         <button
            type="button"
            className="dv-dd__btn dv-dd__trigger"
            onClick={handleToggle}
            aria-haspopup="listbox"
            aria-expanded={open ? "true" : "false"}
         >
            <span className="dv-dd__label">{label}</span>
            <span className="dv-dd__chevron">▾</span>
         </button>
         {open && (
            <div className="dv-dd__menu dv-dd__list" role="listbox">
               {options.map((option) => {
                  const isActive =
                     String(option.value) === String(selectedValue);

                  return (
                     <button
                        key={option.value}
                        type="button"
                        className={
                           "dv-dd__option dv-dd__item" +
                           (isActive ? " dv-dd__option--active" : "")
                        }
                        onClick={() => handleSelect(option.value)}
                        role="option"
                        aria-selected={isActive ? "true" : "false"}
                     >
                        {option.label}
                     </button>
                  );
               })}
            </div>
         )}
      </div>
   );
}

export default memo(SimpleDropdown);
